import React, { Suspense } from "react";
import { Spin } from "antd";
const CategoriesContainer = React.lazy(
  () => import("../../../modules/Categories/components/index")
);

const CategoriesPage = () => (
  <Suspense fallback={<Spin />}>
    <CategoriesContainer />
  </Suspense>
);

export default CategoriesPage;
